import { formatClaimValue } from "@/utils/claims";
import type { ClaimProfile } from "@/types/auth";

export const COMMON_CLAIMS = ["sub", "name", "email", "given_name", "family_name"];

export function ClaimSummary({ profile }: { profile: ClaimProfile }) {
  return (
    <section className="claim-grid" aria-label="Common claims">
      {COMMON_CLAIMS.map((claim) => (
        <article className="claim-card" key={claim}>
          <span>{claim}</span>
          <strong>{formatClaimValue(profile[claim])}</strong>
        </article>
      ))}
    </section>
  );
}
